module.exports = __webpack_public_path__ + "static/img/x2.192d506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sportsBetting/x2.svg
// module id = TBIX
// module chunks = 0